export default __webpack_public_path__ + "static/media/icons8-euro-money-100.9d4080d6.svg";